import {
  TIPO_FLUJO_TESORERIA,
  TipoFlujoTesoreriaType,
} from "api/Types/TipoFlujoTesoreria"
import { TFunction } from "i18next"

export const RemesaTipo = (t: TFunction, tipo?: TipoFlujoTesoreriaType) => {
  return (
    <span>
      {tipo === TIPO_FLUJO_TESORERIA.COBRO
        ? t("cartera.labelCollection")
        : t("cartera.labelPayment")}
    </span>
  )
}
